module.exports = __webpack_public_path__ + "static/media/ICONS_TERMINOS DE PAGO.9ebb6b82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ICONS/ICONS_TERMINOS DE PAGO.svg
// module id = 488
// module chunks = 0